<template>
  <div>
    <b-modal id="modal-tecnicos" size="xl" hide-footer @hidden="handleHidden">
      <template v-slot:modal-title>
        Selecionar técnico
      </template>
      <div class="d-block text-left">
        <p class="font-weight-bold">
          Para concluir a ação, selecione abaixo o técnico responsável.
        </p>

        <div class="row">
          <div
            class="col-12 col-md-6 mb-2"
            v-for="(mecanico, index) in mecanicos"
            :key="index"
          >
            <mecanico-card
              v-on:click="setActive(mecanico)"
              :mecanico="mecanico"
              :active="mecanico === mecanicoAtivo"
            ></mecanico-card>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <b-button
            class="mt-3"
            size="lg"
            block
            @click="$bvModal.hide('modal-tecnicos')"
            >Cancelar</b-button
          >
        </div>
        <div class="col-6">
          <b-button
            class="mt-3 btn-success"
            size="lg"
            block
            :disabled="!mecanicoAtivo"
            >Ok</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MecanicoCard from '@/components/MecanicoCard'

export default {
  components: {
    MecanicoCard
  },

  data () {
    return {
      swalAberto: false
    }
  },

  mounted () {
    this.$store.commit('colaborador/setMecanicoAtivo', null)
  },

  computed: {
    mecanicos () {
      const mecanicos = this.$store.getters['colaborador/mecanicos']

      if (!mecanicos) {
        // this.$store.dispatch('colaborador/loadMecanicos')
        return []
      }

      return mecanicos
    },
    mecanicoAtivo () {
      return this.$store.getters['colaborador/mecanicoAtivo']
    },
    execucaoData () {
      return this.$store.getters['osItemExecucao/data']
    }
  },

  methods: {
    setActive (mecanico) {
      this.swalAberto = true
      this.selected = mecanico
      this.$bvModal.hide('modal-tecnicos')
    },

    handleHidden () {
      if (this.swalAberto) {
        this.abrirModalConfirmar()
        return true
      }

      this.$eventHub.$emit('modal-tecnicos-cancel')
    },

    abrirModalConfirmar () {
      this.$swal.fire({
        title: this.$t('Confirmar identidade'),
        text: this.$t('Informe os três primeiros dígitos do seu CPF para confirmar sua identidade'),
        input: 'text',
        inputAttributes: {
          max: 3
        },
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        onClose: () => {
          this.swalAberto = false
          this.handleHidden()
        },
        preConfirm: cpf => {
          if (cpf !== this.selected.substr_cpf) {
            this.$swal.showValidationMessage('CPF Incorreto')
            return false
          }

          this.emitSelected()
          this.swalAberto = false
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      })
    },
    emitSelected () {
      this.$eventHub.$emit('select-tecnico', this.selected.nr_sequencial)
      this.selected = null
    }
  }
}
</script>
